<template>
  <section class="container-section">
    <div class="sub-container">
      <section class="section-titles">
        <h3 class="title">
          Gestión portuaria
        </h3>
      </section>
      <section>
        <div class="list-items">
          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagementImport.thcPort"
                class="uk-checkbox"
                type="checkbox"
              > THC Puerto
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagementImport.loadVerification"
                class="uk-checkbox"
                type="checkbox"
              >  Verificación Carga
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagementImport.portSecurity"
                class="uk-checkbox"
                type="checkbox"
              > Seguridad Portuaria
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagementImport.fumigationServiceAuthorizationMinSalud"
                class="uk-checkbox"
                type="checkbox"
              > Servicio Fumigacion + Autorizacion Min Salud
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagementImport.refrigeratedLoadElectricalConnection"
                class="uk-checkbox"
                type="checkbox"
              >
              <span v-if="dollyType === dollyTypeEnum.dryLoad"> Conexión Eléctrica Carga seca </span>
              <span v-if="dollyType === dollyTypeEnum.reefer"> Conexión Eléctrica Carga Refrigerada </span>
              <span class="opt"> (Opcional)</span>
            </label>
          </div>

          <div
            class="items uk-flex uk-flex-wrap"
            style="width: 100%"
          >
            <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
              <label style="cursor: pointer">
                <input
                  v-model="terminalManagementImport.internalMovementCostsYard"
                  class="uk-checkbox"
                  type="checkbox"
                  @change="terminalManagementImport.rentalDays = null"
                > Costos Movimientos Internos en Patio
              </label>
            </div>
          </div>

          <div
            class="items uk-flex uk-flex-wrap"
            style="width: 100%"
          >
            <div class="uk-margin-right uk-flex uk-flex-column uk-flex-center">
              <label style="cursor: pointer">
                <input
                  v-model="terminalManagementImport.penaltyTemporaryStorage"
                  class="uk-checkbox"
                  type="checkbox"
                  @change="terminalManagementImport.additionalDays = null"
                >  Penalizacion por Almacenaje Temporal
              </label>
            </div>
            <div class="uk-flex">
              <input
                v-model="terminalManagementImport.additionalDays"
                style="width: 70px; margin: 5px 5px 0px 0px"
                class="uk-input "
                type="number"
                min="0"
                max="9999999"
                :disabled="terminalManagementImport.penaltyTemporaryStorage == null || terminalManagementImport.penaltyTemporaryStorage == false"
                @keydown="$helperPlugin.onlyNumber($event)"
              >
              <label class="uk-flex uk-flex-column uk-flex-center">  Días Adicionales (Después del 5to día) </label>
            </div>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagementImport.XRayInspection"
                class="uk-checkbox"
                type="checkbox"
              >  Inspección Rayos X
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagementImport.furgonTransfer"
                class="uk-checkbox"
                type="checkbox"
              >  Transferencia (furgón – furgón)
            </label>
          </div>
          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagementImport.loadingLashingVehicle"
                class="uk-checkbox"
                type="checkbox"
              >  Carga y trincado del vehículo
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagementImport.noObjectionFumigatedContainers"
                class="uk-checkbox"
                type="checkbox"
              >  No objeción contenedores fumigados
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagementImport.containerImportAgriculturePermit"
                class="uk-checkbox"
                type="checkbox"
              >  Permiso Agricultura importación contenedores
            </label>
          </div>

          <div class="items">
            <label style="cursor: pointer">
              <input
                v-model="terminalManagementImport.portImprovementRate"
                class="uk-checkbox"
                type="checkbox"
              > Tasa de Mejoramiento de Puertos
            </label>
          </div>
        </div>
      </section>
    </div>
    <div class="btn">
      <wizard-button />
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { dollyTypeEnum } from '../../../../types'
export default {
  data () {
    return {
      dollyTypeEnum,

      terminalManagementImport: {
        thcPort: null,
        loadVerification: null,
        portSecurity: null,
        refrigeratedLoadElectricalConnection: null,
        internalMovementCostsYard: null,
        XRayInspection: null,
        furgonTransfer: null,
        loadingLashingVehicle: null,
        fumigationServiceAuthorizationMinSalud: null,
        containerImportAgriculturePermit: null,
        noObjectionFumigatedContainers: null,
        penaltyTemporaryStorage: null,
        additionalDays: null,
        portImprovementRate: null
      }
    }
  },

  computed: {
    ...mapGetters([
      'terminalManagementStore',
      'dollyType'
    ])
  },

  watch: {
    terminalManagementImport: {
      handler: function (newVal) {
        this.$store.commit('setTerminalManagement', newVal)
      }
    }
  },

  mounted () {
    this.terminalManagementImport = { ...this.terminalManagementStore }
  }

}
</script>

<style scoped>
*{
  box-sizing: border-box;
}
p {

  margin: 10px;
}
.uk-padding{
  padding-top: 5px;
  padding-right: 5px;
}
section{
  padding: 10px;
  width: 98%;
}

.title{
  font-weight: 600;
  margin-bottom: 10px;

}
.container-section{
  padding: 10px 40px;
}

.sub-container{
  min-height: 418px;;
}
.section-titles{
  width: 85%;
  padding: 0px
}
.btn{
  padding-right:25px ;
}

.opt{
  font-size: 12px;
  color: rgb(151, 151, 151);

}
.list-items{
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
}
.items{
  min-width: 265px;
  margin: 0px 45px 30px 0px;

}

@media screen and (max-width: 879px){

  .section-titles{
    width: 100%;
    padding: 0px;
  }
  .main{
    padding-top: 25px ;
  }
  .title{
    font-size: 17px;
  }
  .helper{
    font-size: 11px;
  }
  *{
    font-size: 12px;
  }
  .container-section{
    padding: 10px 20px;
  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;

  }
  *{
    font-size: 10px;
  }

  .helper{
    font-size: 10px;
  }
  .item{
    min-width: 100px;
    width: 20%;
    margin: 5px 10px;;
  }

}
</style>
